// This file was auto-generated by Fern from our API Definition.
export var WorkflowRevisionDataOutput;
(function (WorkflowRevisionDataOutput) {
    WorkflowRevisionDataOutput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(WorkflowRevisionDataOutput || (WorkflowRevisionDataOutput = {}));
